<template>
  <div class="qrCodeBody">
    <div class="qrCodeMain">
      <h2 class="title">证书持有人实名认证</h2>
      <div class="qrCode">
        <div class="leftArea">
          <h2>扫码完成个人身份认证</h2>
          <div class="codeArea">
            <img :src="'data:image/png;base64,' + img">
            <dl v-if="isScanning">
              <dt><img src="@/assets/image/accomplish.png"></dt>
              <dd>扫码成功</dd>
            </dl>
          </div>
          <h5>请使用手机微信“扫一扫”<em @click="getCreateFaceUrl">刷新二维码</em></h5>
        </div>
        <div class="demonstration">
          <img src="@/assets/image/demonstration.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img: '',
      intervals: [],
      isScanning: false
    }
  },
  props: ['codeShow','flowId','sesCode'],
  mounted() {
    window.addEventListener('message', this.handleMessageEvent)
  },
  watch:{
    codeShow: function (val, oldVal) {
      if(val === false && oldVal === true){
        this.clearInterval()
      }
      if(val === true) {
        this.isScanning = false
        this.intervals.push(
          setInterval(() => {
            this.getAuthPersonStatus()
          }, 3000)
        )
      }
    },
    sesCode: function (val) {
      if(val) {
        this.img = this.sesCode
      }
    }
  },
  methods: {
    getResult() {
      this.$alert('未查到人脸结果，请扫描二维码并完成人脸识别！', '提示', {
        confirmButtonText: '好的',
        type: 'warning'
      })
    },
    getCreateFaceUrl() {
      // this.isLoad = true
      this.clearInterval()
      this.$api
        .getFaceCode({ flowId: this.flowId })
        .then(res => {
          if (res.code && res.code === '0') {
            this.img = res.data.fileBytes
            this.order = res.data.order
            this.isScanning = false
            // this.isLoad = false
            this.intervals.push(
              setInterval(() => {
                this.getAuthPersonStatus()
              }, 3000)
            )
          } else {
            return new Promise((resolve, reject) => { reject(res)})
          }
        })
        .catch((err) => {
          if(err.code !== '302') {
            this.$emit('sendCode',{code: -1, msg: err.msg|| '认证失败'})
          }
          this.clearInterval()
        })
    },
    getAuthPersonStatus() {
      this.$api
        .checkVerifyStatus({ flowId: this.flowId })
        .then(res => {
          if (res.code && res.code === '0') {
            if (res.data.status === 'DOING') {
              this.isScanning = true
            } else if (res.data.status === 'PASSED') {
              this.clearInterval()
              this.$emit('sendCode',{code: 3})
              // this.$router.push({ name: 'authCompleted' })
            } else if (res.data.status === 'FAILED') {
              // sessionStorage.setItem('verifyMsg', res.msg)
              this.clearInterval()
              this.$emit('sendCode',{code: -2, msg: res.msg})
            }
          } else {
            return new Promise((resolve, reject) => { reject(res)})
          }
        })
        .catch((err) => {
          if(err.code !== '810403') {
            this.$emit('sendCode',{code: -2, msg: err.msg|| '认证失败', result: 3})
          } else if(err.code !== '302') {
            this.$emit('sendCode',{code: -1, msg: err.msg|| '认证失败'})
          }
          this.clearInterval()
        })
    },
    clearInterval() {
      for (let i of this.intervals) {
        clearInterval(i)
      }
    }
  },
  beforeDestroy() {
    this.clearInterval()
  }
}
</script>

<style lang="scss" scoped>
.qrCodeBody {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  background: #f1f3f7;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.qrCodeMain {
  width: 100%;
  flex: 1;
  min-height: 450px;
  margin: 0px auto 0;
  background: #fff;
  padding: 0px 0 40px;
  .title{
    height: 50px;
    border: 1px solid #ECEFF3;
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    margin-bottom: 19px;
    line-height: 50px;
    padding-left: 40px;
    position: relative;
    &::before {
      content: "";
      width: 2px;
      height: 14px;
      background: #4673fd;
      position: absolute;
      top: 52%;
      left: 32px;
      -webkit-transform: translateY(-50%);
    }
  }
}
.qrCode {
  width: max-content;
  margin: 100px auto 0;
  display: flex;
}
.leftArea {
  text-align: center;
  h2 {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    line-height: 27px;
    letter-spacing: 1px;
  }
  h5 {
    margin-top: 14px;
    font-size: 14px;
    color: #595959;
    line-height: 19px;
    font-weight: normal;
  }
  em {
    color: #1c67f3;
    cursor: pointer;
  }
}
.codeArea {
  margin: 24px auto 0;
  width: 160px;
  height: 160px;
  position: relative;
  padding: 11px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #dee0e7;
  img {
    width: 100%;
  }
  dl {
    width: 160px;
    height: 160px;
    position: absolute;
    top: -1px;
    left: -1px;
    background: rgba($color: #fff, $alpha: 0.7);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  dt {
    width: 36px;
    margin: 0 auto;
  }
  dd {
    font-size: 16px;
    color: #333333;
    line-height: 21px;
    letter-spacing: 1px;
    margin-top: 4px;
  }
}
.demonstration {
  margin-top: 13px;
  width: 244px;
  height: 356px;
  margin-left: 135px;
  img {
    width: 100%;
  }
}
</style>